const BaseError = require('make-error').BaseError;

class InUseError extends BaseError {
    constructor(errorMessage='Item is in use. Remove the reference and try again.') {
        super(errorMessage);
    }
}

module.exports = InUseError;